export enum HandshakeType {
  hello_request_0 = 0,
  client_hello_1 = 1,
  server_hello_2 = 2,
  hello_verify_request_3 = 3,
  certificate_11 = 11,
  server_key_exchange_12 = 12,
  certificate_request_13 = 13,
  server_hello_done_14 = 14,
  certificate_verify_15 = 15,
  client_key_exchange_16 = 16,
  finished_20 = 20,
}
